module.exports = __webpack_public_path__ + "static/media/ml.d3aacee0.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/ml.svg
// module id = 2155
// module chunks = 0